export default "__VITE_ASSET__$sffGrqy__"